<ng-container *transloco="let t; prefix: 'widgets.widget-add.feed-options'">
  <h3>{{ t('feed-source') }}</h3>
  <div class="add-feed-options__options-container">
    <xi-dropdown
      select="single"
      [data]="insightFeedSourceOptions"
      [value]="selectedInsightFeedSource"
      (onValueChange)="onInsightFeedSourceChange($event.detail.selected.id)"
    ></xi-dropdown>
    @if (selectedInsightFeedSource === 'selectFeeds') {
      <xi-dropdown
        select="multi"
        [label]="t('feeds')"
        [inMenuSearch]="true"
        [data]="selectedInsightFeedSourceOptions"
        [value]="selectedInsightFeeds"
        (onValueChange)="onInsightFeedsChange($event.detail.selected)"
      ></xi-dropdown>
    }
  </div>
</ng-container>
